export default {
  methods: {
    toWapDetail(item) {
      const {
        news_id: id,
        flag,
        subject_id,
        external_url,
      } = item;
     
      if (flag == 3) {
        return window.open(`${location.origin}/wap/atlasDetails/${id}`)
      } else if ([5, 13, 30, 36].includes(flag)) {
        // 专题专栏
        return window.open(`${location.origin}/wap/subject/${subject_id}/${flag}`)

      } else if ([4, 11, 40, 42].includes(flag)) {
        // 视频详情
        return window.open(`${location.origin}/wap/videoNews/${id}`)

      } else if ([7, 9, 19, 21, 2101, 22, 24, 901, 2401, 25, 2501, 27].includes(+flag)) {
        //直播页面 先用iframe嵌套wap页面
        const formalEnv = location.host.indexOf('cannews.com.cn') > -1 || location.host.indexOf('hkqg.hangkong.com.cn') > -1
        let targetUrl = formalEnv ? 'https://wap.hangkong.com.cn' : 'https://test-wap.hangkong.com.cn'
        if (flag === 7 || flag === 9 || flag === 19 || flag === 21 || flag === 2101 || flag === 22 || flag === 24) {
          targetUrl += '/live_casting.html?news_id=' + id + '&version=new&from=web'
        } else if (flag === 25 || flag === 2501 || flag === 27) {
          targetUrl += '/live_forecast.html?news_id=' + id + '&version=new&from=web'
        } else if (flag == 901 || flag == 2401) {
          targetUrl += '/new_live_casting.html?news_id=' + id + '&version=new&from=web'
        }
        window.open(`${location.origin}/wap/liveNews/${id}?targetUrl=${encodeURIComponent(targetUrl)}`)
        return
      } else if ([10, 14, 55, 56, 57, 58].includes(+flag)) {
        return window.open(external_url)
      } else {
        window.open(`${location.origin}/wap/news/${id}`)
      }
    }
  }
}